const combineValues = (values: (number | string)[], divider: string = '&') => {
  return values.join(divider);
};

const separateValues = (joinedValues: string, divider: string = '&') => {
  return joinedValues.split(divider);
};

export { combineValues, separateValues };
